<template>
  <el-table-column
    prop="product_id"
    label="#"
    show-overflow-tooltip
    width="70"
  >
    <template slot-scope="scope">
      {{ scope.row.product_id }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'product_id',
};
</script>
